var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #029c27;\n        stroke: #029c27;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_without_caption"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WALLET"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,6.1l-6,6,.7.7c.2.2.5.5.8.7,2.7,2,6.4,2,9.1,0,.3-.2.5-.4.8-.7l.7-.7-6-6ZM45.8,13c-1.1,0-2.2-.3-3.1-1l3.1-3.1,3.1,3.1c-.9.6-2,1-3.1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,20.3l-.7.7c-.2.2-.5.5-.7.8-2.1,2.7-2,6.5,0,9.2.2.2.4.5.6.7l.7.7,6-6-6-6ZM60.1,23.2l3.1,3.1-3.1,3.1c-1.3-1.9-1.3-4.3,0-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.9,54.2c-4.7-.1-8.7,3.6-8.8,8.4-.1,4.7,3.6,8.7,8.4,8.8.1,0,.3,0,.4,0h17.7v-17.2h-17.7ZM81.6,69.4h-15.7c-3.6.1-6.7-2.8-6.8-6.4-.1-3.6,2.8-6.7,6.4-6.8.1,0,.2,0,.4,0h15.7v13.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66.6,
    cy: 62.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,8.9l3.1,3.1,1.4,1.4,8.3,8.3,1.4,1.4,3.1,3.1h0c0,0-10.4,10.5-10.4,10.5h2.8l2-2,8.4-8.4-6.1-6.1-8.2-8.2-6-6-6,6-24.7,24.7h2.8l27.9-27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,55.2v-8.7c0-6.5-5.2-11.7-11.7-11.7H7v57.1h60.3c6.5,0,11.7-5.2,11.7-11.7v-9.9h-2v9.9c0,5.3-4.3,9.7-9.7,9.7H9v-53h58.3c5.3,0,9.7,4.3,9.7,9.7v8.7h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,36.8c0-.7,0-1.3,0-2-.5-4.8-4.9-8.3-9.7-7.7-4.1.5-7.3,3.7-7.7,7.7,0,.7,0,1.3,0,2h2c0-.7,0-1.3,0-2,.6-3.7,4-6.2,7.7-5.7,2.9.4,5.2,2.7,5.7,5.7.1.7.1,1.3,0,2h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.7,41.9h-30.9v2h47.2v-2h-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,82.3h47.2v2H16.9v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,16.7h-11.8l4.3-4.3-1.4-1.4-6.7,6.7,6.8,6.8,1.4-1.4-4.3-4.3h11.7c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5h-1.1v2h1.1c7.5,0,13.5-6.1,13.5-13.5s-6.1-13.5-13.5-13.5h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.e3a7c50bf81a5dd3079ac4fcb0dde6fa.svg";
export { ForwardRef as ReactComponent };